
export default {
  inheritAttrs: false,
  props: {
    items: {
      type: Array,
      default: null
    }
  },
  vessel: {
    empty: {
      padding: 'lg',
      borderWidth: 1,
      backgroundColor: 'white'
    }
  }
}
